/* global PAYPAL */
/* This is the script used for fraudNet integration. It is responsible for creating config/data section of the fraudNet and loading fraudNet client side script during initial page loading time */

// Identifier used by fraudNet script to search the config/data section and should never change
const fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99'

function _injectConfig(options) {
  let script = document.getElementById('fconfig')

  if (script && script.parentNode) {
    script.parentNode.removeChild(script)
  }

  script = document.createElement('script')
  script.id = 'fconfig'
  script.type = 'application/json'
  script.setAttribute('fncls', fncls)

  script.text = `{
    "f": "${options.fnSessionId}",
    "s": "${options.sourceId}",
    "mm":true,
    "ts": {
      "type": "${options.sourceId}",
      "fields": [
        {
            "id": "fn-sendRecipient",
            "min": 5
        },
        {
            "id": "fn-amount",
            "min": 3
        },
        {
            "id": "fn-buyRecipient",
            "min": 5
        },
        {
            "id": "fn-requestRecipient",
            "min": 5
        },
        {
            "id": "recipient",
            "min": 5
        },
        {
            "id": "recipientName",
            "min": 5
        },
        {
            "id": "edit-contacts-input",
            "min": 3
        },
        {
            "id": "fn-senderPaysAmount",
            "min": 1
        },
         {
            "id": "fn-recipientGetsAmount",
            "min": 1
        },
         {
            "id": "noteField",
            "min": 5
        },
         {
            "id": "fn-xbCountry",
            "min": 5
        },
        {
            "id": "fn-xbRecipient",
            "min": 5
        },
        {
            "id": "identifierValue",
            "min": 3
        },
        {
            "id": "cvvValue",
            "min": 3
        },
        {
            "id": "shipping_line1",
            "min": 5
        },
        {
            "id": "shipping_line2",
            "min": 5
        },
        {
            "id": "shipping_city",
            "min": 3
        },
        {
            "id": "shipping_postcode",
            "min": 3
        },
        {
            "id": "bill_split_requester",
            "min": 3
        },
        {
            "id": "clipboard-target",
            "min": 1
        }
      ],
      "delegate": true
    }}`

  document.body.appendChild(script)
}

function _loadBeaconJS(options) {
  let script = document.getElementById('fnUrl')
  if (script && script.parentNode) {
    script.parentNode.removeChild(script)
  }

  script = document.createElement('script')
  script.id = 'fnUrl'
  script.src = options.fnUrl
  document.body.appendChild(script)
}

function _retriggerFraudnet() {
  if (
    PAYPAL.asyncData &&
    typeof PAYPAL.asyncData.initAndCollect === 'function'
  ) {
    PAYPAL.asyncData.initAndCollect()
  }
}

export function resetBeaconMetadata(beaconClientMetadata) {
  PAYPAL.ulData = PAYPAL.ulData || {}
  PAYPAL.ulData.fnSessionId = beaconClientMetadata
  _injectConfig(PAYPAL.ulData)
  _retriggerFraudnet()
}

export default {
  trigger(options) {
    if (options) {
      _injectConfig(options)
      _loadBeaconJS(options)
    }
  },
}
